import React,{useState,useContext}from"react";
import{Box,Paper,Typography,TextField,Button,CircularProgress,InputAdornment}from"@mui/material";
import{Email,ArrowBack,VerifiedUser}from"@mui/icons-material";
import{motion}from"framer-motion";
import{useLocation,useNavigate}from"react-router-dom";
import api from"../api/api";
import{AuthContext}from"../AuthContext";

const LoginAuthentication=()=>{

const navigate=useNavigate();
const location=useLocation();
const{setUser}=useContext(AuthContext);

const email=location.state?.email||localStorage.getItem("auth_email");

const[code,setCode]=useState("");
const[loading,setLoading]=useState(false);
const[message,setMessage]=useState("");

const redirectUser=(user)=>{

const role=(user.user_type||user.role||"").toLowerCase();

switch(role){

case"owner":
navigate("/owner-dashboard");
break;

case"admin":
navigate("/newAdminDashboard");
break;

case"proprietor":
navigate("/proprietorDashboard");
break;

case"principal":
navigate("/principalDashboard");
break;

case"teacher":
navigate("/teacher-dashboard");
break;

case"student":
navigate("/student-dashboard");
break;

case"parent":
navigate("/parentsDashboard");
break;

case"registry":
navigate("/registerDashboard");
break;

case"principal":
navigate("/principal-dashboard");
break;

case"vpi":
navigate("/vpiDashboard");
break;

case"vpa":
navigate("/newVpaDashboard");
break;

case"it personel":
navigate("/tTPersonalDashboard");
break;

case"business_manager":
navigate("/businessManagerDashboard");
break;

case"sales_agent":
navigate("/sales-dashboard");
break;

default:
navigate("/");
}

};


const verifyCode=async(e)=>{

e.preventDefault();

if(!email){

setMessage("Authentication email missing. Please login again.");

return;

}

setLoading(true);
setMessage("");

try{

const response = await api.post("/api/users/verify-authentication-code/", {
    email,
    code
});

const access=response.data.access;
const refresh=response.data.refresh;

if(!access||!refresh){

throw new Error("Authentication failed. Tokens missing.");

}

localStorage.setItem("access", access);
localStorage.setItem("refresh", refresh);

/*
 * Notify all authentication-dependent
 * contexts that authentication is ready.
 */
window.dispatchEvent(
    new Event("user-logged-in")
);

const profile = await api.get(
    "/api/user-profile/"
);

const user=profile.data;

setUser(user);

localStorage.setItem("user",JSON.stringify(user));

localStorage.removeItem("auth_email");

redirectUser(user);

}catch(error){

console.error(error);

setMessage(
error.response?.data?.error||
error.response?.data?.detail||
"Invalid authentication code."
);

}finally{

setLoading(false);

}

};


return(

<Box sx={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"linear-gradient(135deg,#F5F5F7,#FFFFFF)",p:3}}>

<motion.div
initial={{opacity:0,y:40}}
animate={{opacity:1,y:0}}
transition={{duration:.7}}
>

<Paper
elevation={0}
sx={{
width:"100%",
maxWidth:450,
p:5,
borderRadius:"30px",
background:"#fff",
border:"1px solid rgba(107,30,45,.12)",
boxShadow:"0 25px 70px rgba(230, 107, 0, 0.15)"
}}
>

<Typography
variant="h4"
fontWeight={900}
sx={{textAlign:"center",color:"#ff7300",mb:2}}
>
Verify Login
</Typography>

<Typography
sx={{textAlign:"center",color:"#666",mb:4}}
>
Enter the authentication code sent to your email.
</Typography>


<form onSubmit={verifyCode}>

<TextField
fullWidth
label="Authentication Code"
variant="filled"
value={code}
onChange={(e)=>setCode(e.target.value)}
required
InputProps={{
startAdornment:(
<InputAdornment position="start">
<VerifiedUser sx={{color:"#ff8800"}}/>
</InputAdornment>
)
}}
sx={{
mb:3,
"& .MuiFilledInput-root":{
borderRadius:"16px",
background:"#F7F7F9"
}
}}
/>


<Button
type="submit"
fullWidth
disabled={loading}
variant="contained"
sx={{
py:1.8,
borderRadius:"16px",
fontWeight:900,
textTransform:"none",
background: "linear-gradient(135deg, #000000, #333333)"
}}
>

{
loading?
<Box sx={{display:"flex",alignItems:"center",justifyContent:"center",gap:1}}>
<CircularProgress size={22} sx={{color:"#ff7300"}}/>
Verifying...
</Box>
:
"Verify Code"
}

</Button>


<Button
fullWidth
variant="outlined"
onClick={()=>navigate("/login")}
startIcon={<ArrowBack/>}
sx={{
mt:2,
py:1.5,
borderRadius:"16px",
fontWeight:800,
textTransform:"none",
color:"#6B1E2D",
border:"2px solid #e06710"
}}
>
Back To Login
</Button>


</form>


{
message&&
<Typography
sx={{
mt:3,
textAlign:"center",
color:"error.main",
fontWeight:700
}}
>
{message}
</Typography>
}


</Paper>

</motion.div>

</Box>

);

};

export default LoginAuthentication;
